import { FormArray } from '@angular/forms';

export function maxSelected(upperBound: number) {
  return (control: FormArray) => {
    if (control.length > upperBound) {
      return { tooManyItems: true };
    }

    return null;
  };
}
